export const GET_DOWNTIMES_REQUEST = 'GET_DOWNTIMES_REQUEST';
export const GET_DOWNTIMES_SUCCESS = 'GET_DOWNTIMES_SUCCESS';
export const GET_DOWNTIMES_ERROR = 'GET_DOWNTIMES_ERROR';

export const STORE_DOWN_TIMES_REQUEST = 'STORE_DOWN_TIMES_REQUEST';
export const STORE_DOWN_TIMES_SUCCESS = 'STORE_DOWN_TIMES_SUCCESS';
export const STORE_DOWN_TIMES_ERROR = 'STORE_DOWN_TIMES_ERROR';
